import type { CollectionDto } from "@serophin/nottldr-shared";
import { articleCount } from "./collectionText";

export type CollectionSelectProps = {
  value: string;
  options: CollectionDto[];
  placeholder: string;
  disabled: boolean;
  onChange: (id: string) => void;
};

export const CollectionSelect = ({ value, options, placeholder, disabled, onChange }: CollectionSelectProps) => (
  <select
    value={value}
    onChange={(event) => onChange(event.currentTarget.value)}
    class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
    disabled={disabled}
  >
    <option value="">{placeholder}</option>
    {options.map((collection) => (
      <option key={collection.id} value={collection.id}>
        {collection.name} ({articleCount(collection.articleCount)})
      </option>
    ))}
  </select>
);

export const ModalButtons = (props: {
  onCancel: () => void;
  onConfirm: () => void;
  busy: boolean;
  disabled?: boolean;
  label: string;
  busyLabel: string;
  danger?: boolean;
}) => (
  <div class="flex space-x-3 pt-2">
    <button
      type="button"
      onClick={props.onCancel}
      disabled={props.busy}
      class="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Cancel
    </button>
    <button
      type="button"
      onClick={props.onConfirm}
      disabled={props.busy || props.disabled}
      class={`flex-1 px-4 py-2 text-white rounded-md disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors ${props.danger ? "bg-red-600 hover:bg-red-700" : "bg-blue-600 hover:bg-blue-700"}`}
    >
      {props.busy ? props.busyLabel : props.label}
    </button>
  </div>
);
